import { useMessages } from '../../contexts/messages';
import React, { useState, useRef } from 'react';
import serviceMethods from '../../service';
import { ensurePhonePrefix } from '../../utils';
import { PLACEHOLDER_FISH_ID_PREFIX } from '../../utils/threadDisplay';
import { focusTextareaAt, insertAtCursor } from '@Utils/insertAtCursor';
import ShowFor from '@Components/ShowFor';
import QuickMessagePicker from '@Components/QuickMessagePicker';
import './index.css';
import { toastError } from '@art-of-hospitality-solutions-llc/ui-kit/components/toast';

const SMSThreadSendBox = ({ recipient, fishId, senderId, onAfterSend }) => {
  const { fetchSmsThread } = useMessages();
  const [text, setText] = useState('');

  const textAreaRef = useRef(null);

  const handleSend = async () => {
    const trimmedText = text.trim();
    if (!trimmedText) return;
    const payload = {
      to: ensurePhonePrefix(recipient),
      body: trimmedText,
      fishId: fishId,
      senderId: senderId,
    };
    try {
      const res = await serviceMethods.immediateSendSMS(payload);

      fetchSmsThread(recipient);
      setText('');
      if (textAreaRef.current) {
        textAreaRef.current.style.height = ''; // Back to its natural one-row height
      }

      // Call the onAfterSend callback if provided
      if (onAfterSend) {
        onAfterSend();
      }
    } catch (error) {
      console.error(error);
      toastError(error.message || 'Failed to update template');
    }
  };

  const handleQuickMessage = (message) => {
    const next = insertAtCursor(textAreaRef.current, text, message.messageBody);
    setText(next.value);
    focusTextareaAt(textAreaRef.current, next.caret);
  };

  return (
    <div className="flex items-end border-t border-gray-300 p-2">
      <ShowFor permissions={['MESSAGE_TEMPLATES_READ']}>
        <QuickMessagePicker
          channel="SMS"
          canResolveMergeTags={
            !!fishId && !String(fishId).startsWith(PLACEHOLDER_FISH_ID_PREFIX)
          }
          onSelect={handleQuickMessage}
        />
      </ShowFor>
      <textarea
        rows="1"
        placeholder="Type a message..."
        className="no-scrollbar max-h-[50vh] min-h-[24px] flex-1 resize-none overflow-y-auto border-none px-2 py-1 outline-none"
        ref={textAreaRef}
        value={text}
        onChange={(e) => {
          setText(e.target.value);
          // Auto-adjust height
          e.target.style.height = 'auto';
          e.target.style.height = e.target.scrollHeight + 'px';
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSend();
          }
        }}
      />
      <button
        onClick={handleSend}
        disabled={!text.trim()}
        className={`ml-2 rounded px-4 py-2 text-white ${
          text.trim() ? 'bg-blue-500 hover:bg-blue-600' : 'bg-gray-400'
        }`}
      >
        Send
      </button>
    </div>
  );
};

export default SMSThreadSendBox;
